export enum ParticipateType {
  INVENTORY = 'INVENTORY',
  CHIPS = 'CHIPS',
  MONEY = 'MONEY',
}
